import supabase from "@/services/supabaseClient";
import { logPasscodeFailureDiagnostic } from "@/lib/passcodeDiagnostics.mjs";

const ALLOWED_PROFILE_TABLES = new Set(["patient_profiles", "doctor_profiles"]);

async function logFailure(input) {
  try {
    await logPasscodeFailureDiagnostic(supabase, input);
  } catch {
    // Diagnostics must never block the user-facing error path.
  }
}

export async function setMyPasscode({
  profileTable,
  passcode,
  userId = "",
  role = "",
  onboardingStep = "step_passcode_confirm",
} = {}) {
  const normalizedTable = String(profileTable || "").trim();
  const normalizedPasscode = String(passcode || "").replace(/\D/g, "");

  if (!ALLOWED_PROFILE_TABLES.has(normalizedTable)) {
    throw new Error(`Invalid profile table: ${normalizedTable}`);
  }

  if (normalizedPasscode.length !== 6) {
    throw new Error("Passcode must be 6 digits.");
  }

  let data = null;
  let error = null;
  try {
    const result = await supabase.functions.invoke("set-passcode", {
      body: {
        profileTable: normalizedTable,
        passcode: normalizedPasscode,
      },
    });
    data = result?.data || null;
    error = result?.error || null;
  } catch (err) {
    error = err;
  }

  if (error) {
    await logFailure({
      userId,
      role,
      profileTable: normalizedTable,
      status: error?.status || error?.context?.status || error?.code || "function_error",
      message: error?.message || String(error || "set-passcode failed"),
      onboardingStep,
    });
    throw error;
  }

  if (!data?.ok) {
    await logFailure({
      userId,
      role,
      profileTable: normalizedTable,
      status: data?.status || "non_ok_response",
      message: data?.error || "Failed to save passcode.",
      onboardingStep,
    });
    throw new Error(data?.error || "Failed to save passcode.");
  }

  return data;
}
